export default __webpack_public_path__ + "static/media/banner.73b8cb5c.png";